// extracted by mini-css-extract-plugin
export default {"iconTextGroupList":"IconTextGroupList_iconTextGroupList__q3edm","iconTextGroup":"IconTextGroupList_iconTextGroup__QuG1G"};